import { useQuery, QueryHookOptions } from '@apollo/react-hooks';
import { GET_EMAILS_FOR_EMAIL_APPLICATIONS_QUERY } from '@frontend/app/queries';
import {
  GetEmailsForEmailApplicationsQuery,
  GetEmailsForEmailApplicationsQueryVariables,
} from '@frontend/app/queries/types/GetEmailsForEmailApplicationsQuery';

type TOptions = QueryHookOptions<GetEmailsForEmailApplicationsQuery, GetEmailsForEmailApplicationsQueryVariables>;

export const useGetEmailsForEmailApplicationsQuery = (options: TOptions) =>
  useQuery<GetEmailsForEmailApplicationsQuery, GetEmailsForEmailApplicationsQueryVariables>(
    GET_EMAILS_FOR_EMAIL_APPLICATIONS_QUERY,
    options,
  );
